module.exports = __webpack_public_path__ + "static/media/interior_point.fcb47d64.md";